import { NgIf } from '@angular/common';
import { Component, TemplateRef, ViewChild, ViewContainerRef, AfterViewInit } from '@angular/core';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'formly-wrapper-addons',
  template: `
  <div *ngIf="readOnly" [innerHtml]="props.readOnlyTemplate(field)"></div>
  <ng-container *ngIf="!readOnly" #fieldComponent></ng-container>
  `,
  standalone: true,
  imports:[FormlyModule, NgIf]
})
export class FormlyWrapperRead extends FieldWrapper {
  @ViewChild('mat-form-field', {read: ViewContainerRef}) fieldComponent!: ViewContainerRef;

  get readOnly() {
    console.log(this.formControl.disabled && this.props.readOnlyTemplate)
    return this.formControl.disabled && this.props.readOnlyTemplate;
  }
}
